import script from "./CheckCompany.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckCompany.vue?vue&type=script&lang=ts&setup=true"

import "./CheckCompany.vue?vue&type=style&index=0&id=6d2e37dc&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2e37dc"]])

export default __exports__